"use strict";
(function (global) {
    //deklaracja klasy
    class SimpleColumnDefinitionSource {
        constructor(config) {
            this.columnDefinitions = [];
            this.init(config);
        }

        //funkcje publiczne
        init(config) {
            const temporaryColumnDefinitions = config.columnDefinitions ? config.columnDefinitions : [];

            this.columnDefinitions = SimpleColumnDefinitionSource.#prepare(temporaryColumnDefinitions);
        }

        /**
         * @param successCallback
         * @param failureCallback
         */
        load(successCallback, failureCallback) {
            successCallback.call(this);
        }

        getColumnDefinitions() {
            return this.columnDefinitions;
        }

        getByDataIndex(dataIndex) {
            let columnDefinition = null;

            for (let key in this.columnDefinitions) {
                if (!this.columnDefinitions.hasOwnProperty(key)) {
                    continue;
                }

                if (this.columnDefinitions[key].dataIndex === dataIndex) {
                    columnDefinition = this.columnDefinitions[key];
                }
            }

            return columnDefinition;
        }

        getByIndex(index) {
            return this.columnDefinitions.length > index ? this.columnDefinitions[index] : null;
        }

        count() {
            return this.columnDefinitions.length;
        }

        /**
         * Funkcja zwraca indeks pierwszej edytowalnej kolumny.
         *
         * @param newRecord - true oznacza, ze dla nowego rekordu (dodawanie rekordu), false oznacza, ze przy edycji rekordu
         * @returns {Number}
         */
        getFirstEditableDataIndex(newRecord) {
            newRecord = !!newRecord;

            let firstEditableDataIndex = null;

            for (let key in this.columnDefinitions) {
                if (!this.columnDefinitions.hasOwnProperty(key)) {
                    continue;
                }

                const columnIsEditable = this.columnDefinitions[key].isEditable;
                const columnIsEditableOnAdd = this.columnDefinitions[key].isEditableOnAdd;

                if ((columnIsEditable && newRecord === false) || (columnIsEditableOnAdd && newRecord === true)) {
                    firstEditableDataIndex = this.columnDefinitions[key].dataIndex;
                    break;
                }
            }

            return firstEditableDataIndex;
        }

        //funkcje prywatne
        static #prepare(temporaryColumnDefinitions) {
            const results = [];

            let columnIndex = 0;
            const length = temporaryColumnDefinitions.length;
            for (; columnIndex < length; columnIndex++) {
                const temporaryColumnDefinition = temporaryColumnDefinitions[columnIndex];

                const resolver = new NS.Utils.OptionsResolver(temporaryColumnDefinition);
                const columnDefinition = {
                    "label": temporaryColumnDefinition.label ? temporaryColumnDefinition.label : "Column " + parseInt(columnIndex),
                    "dataIndex": temporaryColumnDefinition.dataIndex ? temporaryColumnDefinition.dataIndex : "data_" + parseInt(columnIndex),
                    "dataType": temporaryColumnDefinition.dataType ? temporaryColumnDefinition.dataType : "text",
                    "isEditable": temporaryColumnDefinition.isEditable ? temporaryColumnDefinition.isEditable : false,
                    "isEditableOnAdd": temporaryColumnDefinition.isEditableOnAdd ? temporaryColumnDefinition.isEditableOnAdd : false,
                    "isSortable": resolver.getOption("isSortable", true),
                    "isFilterable": resolver.getOption("isFilterable", true),
                    "isMovable": temporaryColumnDefinition.isMovable ? temporaryColumnDefinition.isMovable : true,
                    "width": temporaryColumnDefinition.width ? temporaryColumnDefinition.width : null,
                    "minWidth": temporaryColumnDefinition.minWidth ? temporaryColumnDefinition.minWidth : null
                };

                results.push(columnDefinition);
            }

            return results;
        }

    }

    //wyeksportowanie klasy
    global.NS = global.NS || {};
    global.NS.Grid = global.NS.Grid || {};
    global.NS.Grid.SimpleColumnDefinitionSource = SimpleColumnDefinitionSource;
})(window);
